module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-businesskit-assignement "
  }, [_c('assignment-modal', {
    attrs: {
      "collection": _vm.filteredBusinesskits,
      "assignedCollection": _vm.assignedBusinessKitList,
      "title": _vm.computedTitle,
      "subtitle": _vm.computedSubtitle,
      "open": _vm.isOpen,
      "searchPlaceholder": "bk",
      "displayName": "name"
    },
    on: {
      "close": _vm.close,
      "save": _vm.save
    }
  }), _vm._v(" "), (this.assignedBusinesskits.length === 0) ? _c('div', {
    staticClass: "empty-state-assignment"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/businesskit.svg")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.pages.project-no-assigned-businesskit')))]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('span', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.isOpen = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.project-assign-businesskit')) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (this.assignedBusinesskits.length > 0) ? _c('div', {
    staticClass: "project-businesskit-assignement--monitor"
  }, [_c('h3', [_vm._v("\n      " + _vm._s(_vm.$t('ui.pages.project-assigned-businesskit')) + ":\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.isOpen = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.project-assign-businesskit')) + "\n      ")]), _vm._v(" "), _vm._l((_vm.assignedBusinessKitList), function(businesskit) {
    return _c('div', {
      key: businesskit.id,
      staticClass: "businesskit"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/bk.svg")
      }
    }), _vm._v(" "), _c('div', [_c('h4', {
      staticClass: "businesskit-name"
    }, [_vm._v("\n          " + _vm._s(businesskit.name) + "\n        ")]), _vm._v(" "), (businesskit.preview_url) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": businesskit.preview_url,
        "target": "_blank"
      }
    }, [_vm._v("\n          Preview\n        ")]) : _vm._e()])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5f731de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/ProjectBusinesskitAssignement.vue
// module id = 1979
// module chunks = 0